import { createRoot } from 'react-dom/client';

import App from './DynamicRegistrationApp';

const container = document.getElementById('react-root');
const root = createRoot(container);

root.render(<App />);
